import { SEARCH_ORIGIN_QUERY_PARAM } from 'app/constants/AnalyticsConstants';

// The applied sort's id drives the `ui_content_sort` analytics field.
function selectAppliedSortId(sortBys) {
  return sortBys.find(sortBy => sortBy.get('applied'))?.get('id');
}

// The `search` analytics entity: an in-URL origin param wins over the cached search origin.
export function buildSearchEntity({ query, searchType, searchOrigin, router }) {
  const origin = router?.query[SEARCH_ORIGIN_QUERY_PARAM] || searchOrigin;

  return {
    search_origin: origin,
    search_query: query,
    search_type: searchType
  };
}

// The full catalog_search tracking payload fired on mount (and on fetch completion).
export default function buildCatalogSearchPayload({
  query,
  searchType,
  searchOrigin,
  router,
  currentView,
  pagination,
  sortBys
}) {
  return {
    search: buildSearchEntity({ query, searchType, searchOrigin, router }),
    ui: {
      ui_content_layout: currentView,
      ui_content_page: pagination.get('page'),
      ui_content_sort: selectAppliedSortId(sortBys),
      ui_content_total_count: pagination.get('count')
    }
  };
}
